import React, { useState, useEffect, useRef, useCallback } from "react";
import { Pannellum } from "pannellum-react";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import MenuIcon from "@mui/icons-material/Menu";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import CloseIcon from '@mui/icons-material/Close';
import Fullscreen from "fullscreen-react";
import Slide from "@mui/material/Slide";
import { useNavigate } from "react-router-dom";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

import projectorIcon from "../../images/icons/projector.svg";
import AllLocations from "../../components/AllLocations";
import FooterIconBar from "../../components/FooterIconBar";
import TutorialSlider from "../../components/TutorialSlider";
import Loading from "../../components/Loading";

import axios from "axios";
import Invisible from "../../components/Invisible";
import Skeleton from "@mui/material/Skeleton";

import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import Team from "../../components/Team";
import { useContext } from "react";
import { ThemeAudioContext } from "../../components/ThemeAudioContext";
import PlayArrowOutlinedIcon from '@mui/icons-material/PlayArrowOutlined';
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import PeopleOutlineOutlinedIcon from "@mui/icons-material/PeopleOutlineOutlined";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const SilverDoor = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isShowFooter, setIsShowFooter] = useState(false);

  const [locationDetails, setLocationDetails] = React.useState([]);
  const [locationName, setLocationName] = React.useState("");
  const [hotspotText, setHostpotDescription] = React.useState("");
  const [hotspotArray, setHotspotArray] = useState([]);
  const [hotspotImage, setHotspotImage] = useState("");
  const [audio, setAudio] = useState(new Audio(null));
  const [playAudio, setPlayAudio] = React.useState(false);
  const [showAudio, setShowAudio] = React.useState(false);
  const [showIframe, setShowIframe] = React.useState(false);
  const [iframeUrl, setIframeUrl] = useState("");
  const [showImageLoading, setShowImageLoading] = React.useState(false);
  const [hotspotTitle, setHostpotTitle] = React.useState("");
  const [imageOneSrc, setImageOneSrc] = React.useState("");
  const [presentationOpen, setPresentationOpen] = React.useState(false);
  const [showSnackBar, setShowSnackBar] = React.useState(false);
  const [variable, setVariable] = useState(null);

  const [showMenuBtn, setShowMenuBtn] = useState(false);

  const [open, setOpen] = React.useState(false);
  const [hotspotOpen, setHotspotOpen] = React.useState(false);
  const [fullImageOpen, setFullImageOpen] = React.useState(false);
  const [imageIndex, setImageIndex] = React.useState(1);
  const [seeMore, setSeeMore] = React.useState(false);
  const [tutorialOpen, setTutorialOpen] = React.useState(false);
  const navigate = useNavigate();
  const [hfov, setHfov] = React.useState(100);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const menuOpen = Boolean(anchorEl);

  const [currentAutoplayDuration, setAutoplayDuration] = useState(null);
  const [watermarkLogoUrl, setWatermarkLogoUrl] = useState("");
  const [showWatermarkLogo, setShowWatermarkLogo] = useState(false);
  const [themeAudio, setThemeAudio] = useState(new Audio(null));
  const [autoplayEnabled, setAutoplayEnabled] = useState(false);
  const [teamOpen, setTeamOpen] = React.useState(false);
  const [showTeamDetailsBool, setShowTeamDetails] = useState(false);

  const narrationAudioRef = useRef(null);
  const playedNarrationsSilverDoor = useRef({});
  const [countdown, setCountdown] = useState(currentAutoplayDuration);
  const [isPaused, setIsPaused] = useState(false);

  const [themeAudioEnabled, setThemeAudioEnabled] = useState(() => {
    return sessionStorage.getItem("isThemeAudioEnabled") === "true";
  });

  const screenAudioRef = useRef(null);

  const {
    toggleAudio,
    enabled,
    setAudioSource,
    pauseThemeAudio,
    resumeThemeAudio,
    reduceThemeAudioVolume,
    restoreThemeAudioVolume,
  } = useContext(ThemeAudioContext);
  const [globalSettings, setGlobalSettings] = useState(null);
  let handleNarrationRetryClick = null;

  const fadeAnimationRef = useRef(null);

  const menuTranslations = {
    en: {
      home: "Home",
      tutorial: "Tutorial",
      team: "Team",
      fullscreen: "Full Screen",
      themeAudio: "Theme Audio",
      autoplay: "Autoplay",
    },
    sl: {
      home: "මුල් පිටුව",
      tutorial: "උපදෙස්",
      team: "කණ්ඩායම",
      fullscreen: "පූර්ණ තිරය",
      themeAudio: "තේමා ශ්‍රව්‍ය",
      autoplay: "ස්වයංක්‍රීය ධාවනය",
    },
    tm: {
      home: "முகப்பு",
      tutorial: "வழிகாட்டி",
      team: "குழு",
      fullscreen: "முழுத்திரை",
      themeAudio: "தீம் ஆடியோ",
      autoplay: "தானியங்கி இயக்கம்",
    },
  };

  const [language, setLanguage] = useState(
    localStorage.getItem("language") || "en"
  );

  const t = menuTranslations[language] || menuTranslations.en;

  useEffect(() => {
    const currentLanguage = localStorage.getItem("language") || "en";
    setLanguage(currentLanguage);
  }, []);

  useEffect(() => {
    // 🔥 kill background audio
    if (window.__BG_AUDIO__) {
      try {
        window.__BG_AUDIO__.pause();
        window.__BG_AUDIO__.currentTime = 0;
      } catch (e) { }
      window.__BG_AUDIO__ = null;
    }

    // 🔥 kill narration audio
    if (window.__NARRATION_AUDIO__) {
      try {
        window.__NARRATION_AUDIO__.pause();
        window.__NARRATION_AUDIO__.currentTime = 0;
      } catch (e) { }
      window.__NARRATION_AUDIO__ = null;
    }

    // 🔥 also kill any DOM audio just in case
    document.querySelectorAll("audio").forEach((a) => {
      try {
        a.pause();
        a.currentTime = 0;
      } catch (e) { }
    });
  }, []);

  useEffect(() => {
    const audio = new Audio(
      "https://res.cloudinary.com/giglantis/video/upload/v1777527147/Silver_Door_ztwz3k.mp3"
    );

    audio.loop = true;
    audio.volume = 0.5;

    window.__BG_AUDIO__ = audio;
    screenAudioRef.current = audio;

    return () => {
      audio.pause();
      audio.currentTime = 0;

      if (window.__BG_AUDIO__ === audio) {
        window.__BG_AUDIO__ = null;
      }

      if (screenAudioRef.current === audio) {
        screenAudioRef.current = null;
      }
    };
  }, []);

  useEffect(() => {
    const audio = screenAudioRef.current;

    if (!audio || !themeAudioEnabled) return;

    audio.play().catch((err) => {
      console.log("BG AUDIO PLAY FAILED:", err);
    });
  }, [themeAudioEnabled]);

  const handleThemeAudioToggle = () => {
    setThemeAudioEnabled((prev) => {
      const next = !prev;

      sessionStorage.setItem("isThemeAudioEnabled", next ? "true" : "false");

      const audio = screenAudioRef.current;

      if (next) {
        if (audio) {
          audio.play().catch(() => { });
        }
      } else {
        if (audio) {
          audio.pause();
          audio.currentTime = 0;
        }
      }

      return next;
    });
  };

  const fadeThemeAudio = (target, duration = 500) => {
    const audio = screenAudioRef.current;

    if (!audio) {
      console.log("No theme audio ref");
      return;
    }


    if (fadeAnimationRef.current) {
      cancelAnimationFrame(fadeAnimationRef.current);
    }

    const start = audio.volume;
    const startTime = performance.now();

    const fade = (currentTime) => {
      const progress = Math.min(
        (currentTime - startTime) / duration,
        1
      );

      audio.volume = start + (target - start) * progress;

      if (progress < 1) {
        fadeAnimationRef.current = requestAnimationFrame(fade);
      } else {
        audio.volume = target;
        fadeAnimationRef.current = null;

      }
    };

    fadeAnimationRef.current = requestAnimationFrame(fade);
  };

  const fadeOutThemeAudio = (target = 0.2, duration = 500) => {
    const audio = screenAudioRef.current;
    if (!audio) return;

    const start = audio.volume;
    const diff = start - target;
    const steps = 30;
    const stepTime = duration / steps;

    let i = 0;

    const interval = setInterval(() => {
      i++;
      audio.volume = start - (diff * (i / steps));

      if (i >= steps) {
        audio.volume = target;
        clearInterval(interval);
      }
    }, stepTime);
  };

  const fadeInThemeAudio = (target = 0.5, duration = 500) => {
    const audio = screenAudioRef.current;
    if (!audio) return;

    const start = audio.volume;
    const diff = target - start;
    const steps = 30;
    const stepTime = duration / steps;

    let i = 0;

    const interval = setInterval(() => {
      i++;
      audio.volume = start + (diff * (i / steps));

      if (i >= steps) {
        audio.volume = target;
        clearInterval(interval);
      }
    }, stepTime);
  };

  const stopThemeAudioBeforeNav = () => {
    const audio = screenAudioRef.current;

    if (audio) {
      audio.pause();
      audio.currentTime = 0;
    }

    screenAudioRef.current = null;
  };

  useEffect(() => {
    if (!isLoading) {
      getColors();
      getTeamDetails();
      const timer = setTimeout(() => {
        setShowMenuBtn(true);
      }, 3000); // 1 second delay

      return () => clearTimeout(timer);
    } else {
      setShowMenuBtn(false);
    }
  }, [isLoading]);

  const getColors = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_API + "Colors/getColors"
      );
      document.documentElement.style.setProperty(
        "--primary-color",
        response.data.primaryColor
      );
      document.documentElement.style.setProperty(
        "--secondary-color",
        response.data.secondaryColor
      );
    } catch (error) {
      console.error(error);
      console.log("There was an error!", error);
    }
  };

  const getTeamDetails = useCallback(async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_API + "Teams/getTeamDetails"
      );
      setShowTeamDetails(
        response.data.showTeamDetails?.toString().trim().toLowerCase() ===
        "true"
      );
    } catch (error) {
      console.error(error);
    }
  }, []);

  const getGlobalSettings = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_API + "GlobalSettings/getGlobalSettings"
      );
      const settings = response.data;
      setGlobalSettings(settings);
      setAutoplayDuration(response.data?.autoplayDuration);
      setWatermarkLogoUrl(response.data?.watermarkLogo);
      setShowWatermarkLogo(response.data?.showWatermarkLogo);
    } catch (error) {
      console.error(error);
    }
  };

  const handleAutoplayToggle = () => {
    setAutoplayEnabled((prev) => {
      const newValue = !prev;
      sessionStorage.setItem("isAutoplayEnabled", newValue ? "true" : "false");
      return newValue;
    });
  };

  const handleFooterMenuToggle = (isOpen) => {
    if (isOpen) {
      setAutoplayEnabled(false);
      setIsPaused(true);
    } else if (!isOpen) {
      setAutoplayEnabled(sessionStorage.getItem("isAutoplayEnabled") === "true");
      setIsPaused(false);
    }
  };

  useEffect(() => {
    const isEnabled = sessionStorage.getItem("isAutoplayEnabled") === "true";
    if (!isEnabled) {
      return;
    }
    setAutoplayEnabled(true);
    return;
  }, [autoplayEnabled]);

  useEffect(() => {
    if (!autoplayEnabled || !currentAutoplayDuration) return;

    setCountdown(currentAutoplayDuration); // reset visible timer
    let interval = null;

    if (!isPaused) {
      interval = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(interval);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }

    return () => clearInterval(interval);
  }, [autoplayEnabled, currentAutoplayDuration, isPaused]);

  useEffect(() => {
    if (!autoplayEnabled || !currentAutoplayDuration || isPaused) return;
    if (!locationDetails || locationDetails.length === 0) return; // <-- wait for data

    const timer = setTimeout(() => {
      if (imageIndex < 1) {
        changeImage(imageIndex + 1);
        setCountdown(currentAutoplayDuration);
        setIsPaused(true); // temporarily pause
        setTimeout(() => setIsPaused(false), 0);
      } else {
        navigateChamber();
      }
    }, currentAutoplayDuration * 1000);

    return () => clearTimeout(timer);
  }, [
    autoplayEnabled,
    currentAutoplayDuration,
    imageIndex,
    isPaused,
    locationDetails,
  ]);

  useEffect(() => {
    setThemeAudioEnabled(enabled);
  }, [enabled]);

  useEffect(() => {
    const stored = sessionStorage.getItem("playedNarrationsSilverDoor");
    if (stored) {
      playedNarrationsSilverDoor.current = JSON.parse(stored);
    } else {
      playedNarrationsSilverDoor.current = {};
    }
  }, []);

  const markNarrationPlayed = (index) => {
    playedNarrationsSilverDoor.current[index] = true;
    sessionStorage.setItem(
      "playedNarrationsSilverDoor",
      JSON.stringify(playedNarrationsSilverDoor.current)
    );
  };

  const getLocationDetails = async () => {
    setIsShowFooter(false);
    setIsLoading(true);
    try {
      const response = await axios.get(
        process.env.REACT_APP_API +
        "Locations/locationDetails/getDetailsByLocation/silver%20door"
      );
      setLocationDetails(response.data);
      switch (localStorage.getItem("language")) {
        case "en":
          setLocationName(response.data[0].nameInEnglish);
          break;
        case "sl":
          setLocationName(response.data[0].nameInSinhala);
          break;
        case "tm":
          setLocationName(response.data[0].nameInTamil);
          break;
        default:
          setLocationName(response.data[0].nameInEnglish);
          break;
      }
      if (window.innerWidth < 481) {
        setImageOneSrc(response.data[0].lowResLocationImage);
      } else {
        setImageOneSrc(response.data[0].locationImage);
      }
      setImageIndex(1);
      if (response.data[0].hotspotArray) {
        let hotspot = response.data[0].hotspotArray;

        if (!hotspot) {
          setHotspotArray([]);
          return;
        }

        let parsedHotspots = []

        try {
          const cleaned = hotspot
            .replace(/[\u0000-\u001F]/g, "") // removes control characters
            .replace(/\n/g, "\\n")           // escape new lines
            .replace(/\r/g, "");
          parsedHotspots = JSON.parse(cleaned);
          setHotspotArray(JSON.parse(cleaned));
        } catch (e) {
          console.error("Hotspot JSON invalid:", e);
          setHotspotArray([]);
          return;
        }
        const lang = localStorage.getItem("language") || "en";
        // Map each hotspot index to its CSS variables and element classes
        const hotspotConfig = [
          {
            className: "loc-hotspot",
            textVar: "--hotspotText",
          },
        ];
        parsedHotspots.forEach((hotspot, index) => {
          if (!hotspot) return; // Skip if undefined/null

          const config = hotspotConfig[index];
          if (!config) return; // Skip if no config for this index

          const elements = document.getElementsByClassName(config.className);

          if (hotspot.disable) {
            // Hide hotspot
            Array.from(elements).forEach((el) => {
              el.style.visibility = "hidden";
              el.style.display = "none";
            });
          } else {
            // Pick hotspot text based on language
            let hotspotString = "";
            switch (lang) {
              case "en":
                hotspotString = `'${hotspot.hotspotTitleEnglish.replace(
                  /'/g,
                  "\\'"
                )}'`;
                break;
              case "sl":
                hotspotString = `'${hotspot.hotspotTitleSinhala}'`;
                break;
              case "tm":
                hotspotString = `'${hotspot.hotspotTitleTamil}'`;
                break;
              default:
                hotspotString = `'${hotspot.hotspotTitleEnglish.replace(
                  /'/g,
                  "\\'"
                )}'`;
                break;
            }
            // Apply CSS variables
            document.documentElement.style.setProperty(
              config.textVar,
              hotspotString
            );
          }
        });
      } else {
        setHotspotArray([]);
      }
      setIsLoading(false);
    } catch (error) {
      console.error(error);
      console.log("There was an error!", error);
    }
  };

  const playNarrationAudio = (index, locationDetails) => {
    const frequency = globalSettings?.narrationAudioFrequency || "Once";

    if (
      frequency === "Once" &&
      playedNarrationsSilverDoor.current[index]
    ) {
      return;
    }

    if (narrationAudioRef.current) {
      return;
    }

    let audioUrl = "";

    switch (localStorage.getItem("language")) {
      case "en":
        audioUrl = locationDetails[index]?.narrationAudio;
        break;
      case "sl":
        audioUrl = locationDetails[index]?.narrationAudioSinhala;
        break;
      case "tm":
        audioUrl = locationDetails[index]?.narrationAudioTamil;
        break;
      default:
        break;
    }

    if (!audioUrl) return;

    stopNarrationAudio();

    // 🔻 Lower theme audio when narration starts
    fadeThemeAudio(0.2, 500);

    const audio = new Audio(audioUrl);

    window.__NARRATION_AUDIO__ = audio;

    audio.loop = false;
    audio.muted = false;
    audio.currentTime = 0;

    narrationAudioRef.current = audio;

    audio.play()
      .then(() => {
        markNarrationPlayed(index);
      })
      .catch(() => {
        const retry = () => {
          // Make sure theme is still low when retrying narration
          fadeThemeAudio(0.2, 500);

          audio.currentTime = 0;

          audio.play().then(() => {
            markNarrationPlayed(index);
          });
        };

        window.addEventListener("click", retry, { once: true });
      });

    audio.onended = () => {
      narrationAudioRef.current = null;

      // 🔺 Restore theme audio after narration ends
      fadeThemeAudio(0.5, 500);
    };
  };

  const stopNarrationAudio = () => {
    const audio = narrationAudioRef.current;

    if (audio) {
      audio.pause();
      audio.currentTime = 0;

      audio.src = "";
      audio.removeAttribute("src");

      audio.onended = null;

      narrationAudioRef.current = null;
    }

    if (handleNarrationRetryClick) {
      window.removeEventListener("click", handleNarrationRetryClick);
      handleNarrationRetryClick = null;
    }

    // 🔺 Restore theme audio because narration has stopped
    fadeThemeAudio(0.5, 500);
  };

  const pauseNarrationAudio = () => {
    const audio = narrationAudioRef.current;

    if (audio && !audio.paused) {
      audio.pause();

      // 🔺 Theme back up
      fadeThemeAudio(0.5, 500);
    }
  };

  const resumeNarrationAudio = async () => {
    const audio = narrationAudioRef.current;

    if (audio && audio.paused) {
      // 🔻 Theme down
      fadeThemeAudio(0.2, 500);

      try {
        await audio.play();
      } catch (err) {
        console.log("Narration resume failed:", err);
      }
    }
  };

  const onImageLoad = () => {
    setTimeout(() => {
      setIsShowFooter(true);
      playNarrationAudio(imageIndex - 1, locationDetails);
    }, 1000);
  };

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
    setAutoplayEnabled(false);
    setIsPaused(true);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
    setAutoplayEnabled(sessionStorage.getItem("isAutoplayEnabled") === "true");
    setIsPaused(false);
  };

  const seeMoreClick = () => {
    setSeeMore(true);
  };

  const seeLessClick = () => {
    setSeeMore(false);
  };

  useEffect(() => {
    const saved = sessionStorage.getItem("isThemeAudioEnabled");
    if (saved === null) {
      sessionStorage.setItem("isThemeAudioEnabled", "true");
      setThemeAudioEnabled(true);
    } else {
      setThemeAudioEnabled(saved === "true");
    }
    const savedAutoplay = sessionStorage.getItem("isAutoplayEnabled");
    if (savedAutoplay === null) {
      sessionStorage.setItem("isAutoplayEnabled", "true");
      setAutoplayEnabled(true);
    } else {
      setAutoplayEnabled(savedAutoplay === "true");
    }
    getLocationDetails();
    localStorage.setItem("silverDoor", "1");
    setHotspotOpen(false);
    setFullImageOpen(false);
    getGlobalSettings();
    if (window.innerWidth < 481) {
      setHfov(20);
    } else {
      setHfov(130);
    }
  }, []);

  const changeImage = (id) => {
    const clickAudio = new Audio("https://res.cloudinary.com/giglantis/video/upload/v1777459238/TABS_smeb0h.mp3");
    clickAudio.volume = 1;
    clickAudio.play().catch((err) => {
      console.log(err);
    });
    if (!locationDetails || locationDetails.length === 0) return; // <-- ADD THIS
    const index = id - 1;
    if (!locationDetails[index]) return;
    let hotspotString = "";
    setHotspotOpen(false);
    setShowIframe(false);
    setIframeUrl("");
    setFullImageOpen(false);
    setShowImageLoading(false);
    stopNarrationAudio();
    switch (id) {
      case 1:
        switch (localStorage.getItem("language")) {
          case "en":
            setLocationName(locationDetails[0].nameInEnglish);
            break;
          case "sl":
            setLocationName(locationDetails[0].nameInSinhala);
            break;
          case "tm":
            setLocationName(locationDetails[0].nameInTamil);
            break;
          default:
            setLocationName(locationDetails[0].nameInEnglish);
            break;
        }
        setImageIndex(1);
        playNarrationAudio(0, locationDetails);
        if (locationDetails[0].hotspotArray) {
          let hotspot = locationDetails[0].hotspotArray;

          if (!hotspot) {
            setHotspotArray([]);
            return;
          }
          let parsedHotspots = []

          try {
            const cleaned = hotspot
              .replace(/[\u0000-\u001F]/g, "") // removes control characters
              .replace(/\n/g, "\\n")           // escape new lines
              .replace(/\r/g, "");
            parsedHotspots = JSON.parse(cleaned);
            setHotspotArray(JSON.parse(cleaned));
          } catch (e) {
            console.error("Hotspot JSON invalid:", e);
            setHotspotArray([]);
            return;
          }
          const lang = localStorage.getItem("language") || "en";
          // Map each hotspot index to its CSS variables and element classes
          const hotspotConfig = [
            {
              className: "loc-hotspot",
              textVar: "--hotspotText",
            },
          ];
          parsedHotspots.forEach((hotspot, index) => {
            if (!hotspot) return; // Skip if undefined/null

            const config = hotspotConfig[index];
            if (!config) return; // Skip if no config for this index

            const elements = document.getElementsByClassName(config.className);

            if (hotspot.disable) {
              // Hide hotspot
              Array.from(elements).forEach((el) => {
                el.style.visibility = "hidden";
                el.style.display = "none";
              });
            } else {
              // Pick hotspot text based on language
              let hotspotString = "";
              switch (lang) {
                case "en":
                  hotspotString = `'${hotspot.hotspotTitleEnglish.replace(
                    /'/g,
                    "\\'"
                  )}'`;
                  break;
                case "sl":
                  hotspotString = `'${hotspot.hotspotTitleSinhala}'`;
                  break;
                case "tm":
                  hotspotString = `'${hotspot.hotspotTitleTamil}'`;
                  break;
                default:
                  hotspotString = `'${hotspot.hotspotTitleEnglish.replace(
                    /'/g,
                    "\\'"
                  )}'`;
                  break;
              }
              // Apply CSS variables
              document.documentElement.style.setProperty(
                config.textVar,
                hotspotString
              );
            }
          });
        } else {
          setHotspotArray([]);
        }
        break;
      default:
        break;
    }
    setCountdown(currentAutoplayDuration);
  };

  const goPrevious = () => {
    const clickAudio = new Audio("https://res.cloudinary.com/giglantis/video/upload/v1777459155/PREVIOUS_fpkysr.mp3");
    clickAudio.volume = 1;
    clickAudio.play().catch((err) => {
      console.log(err);
    });
    let hotspotString = "";
    setHotspotOpen(false);
    setShowIframe(false);
    setIframeUrl("");
    setFullImageOpen(false);
    setShowImageLoading(false);
    stopNarrationAudio();
    switch (imageIndex) {
      case 1:
        stopNarrationAudio();
        stopThemeAudioBeforeNav();
        const clickAudio = new Audio("https://res.cloudinary.com/giglantis/video/upload/v1777459643/LOCATION_CHANGE_oc2l0j.mp3");
        clickAudio.volume = 1;
        clickAudio.play().catch((err) => {
          console.log(err);
        });
        navigate("/public-entrance");
        break;
      default:
        break;
    }
    setCountdown(currentAutoplayDuration);
  };

  const goNext = () => {
    const clickAudio = new Audio("https://res.cloudinary.com/giglantis/video/upload/v1777459124/NEXT_ckeozx.mp3");
    clickAudio.volume = 1;
    clickAudio.play().catch((err) => {
      console.log(err);
    });
    let hotspotString = "";
    setHotspotOpen(false);
    setShowIframe(false);
    setIframeUrl("");
    setFullImageOpen(false);
    setShowImageLoading(false);
    stopNarrationAudio();
    switch (imageIndex) {
      case 1:
        stopNarrationAudio();
        stopThemeAudioBeforeNav();
        const clickAudio = new Audio("https://res.cloudinary.com/giglantis/video/upload/v1777459643/LOCATION_CHANGE_oc2l0j.mp3");
        clickAudio.volume = 1;
        clickAudio.play().catch((err) => {
          console.log(err);
        });
        navigate("/chamber");
        break;
      default:
        break;
    }
    setCountdown(currentAutoplayDuration);
  };

  const handleClickOpen = () => {
    const clickAudio = new Audio("https://res.cloudinary.com/giglantis/video/upload/v1777459238/TABS_smeb0h.mp3");
    clickAudio.volume = 1;
    clickAudio.play().catch((err) => {
      console.log(err);
    });
    pauseNarrationAudio();
    fadeThemeAudio(0.2, 500);
    setAutoplayEnabled(false);
    setIsPaused(true);
    setOpen(true);
  };

  const handleClose = () => {
    const clickAudio = new Audio("https://res.cloudinary.com/giglantis/video/upload/v1777459238/TABS_smeb0h.mp3");
    clickAudio.volume = 1;
    clickAudio.play().catch((err) => {
      console.log(err);
    });
    setOpen(false);
    setAutoplayEnabled(sessionStorage.getItem("isAutoplayEnabled") === "true");
    setIsPaused(false);
    resumeNarrationAudio();
    resumeThemeAudio();
    fadeThemeAudio(0.5, 500);
  };

  const handleHotspotClickOpen = (hotspotIndex) => {
    const clickAudio = new Audio("https://res.cloudinary.com/giglantis/video/upload/v1777457711/HOTSPOT_dmleko.mp3");
    clickAudio.volume = 1;
    clickAudio.play().catch((err) => {
      console.log(err);
    });
    fadeThemeAudio(0.2, 500);
    setAutoplayEnabled(false);
    setIsPaused(true);
    setShowImageLoading(true);
    setShowIframe(false);
    setIframeUrl("");
    setHotspotOpen(false);
    setFullImageOpen(false);
    setHotspotImage("");
    setHostpotDescription("");
    setHostpotTitle("");

    let hotspotArray = JSON.parse(locationDetails[0].hotspotArray || "[]");
    let hotspotJSON = locationDetails[0].hotspotArray;
    if (!hotspotJSON) {
      hotspotArray = [];
      return;
    }
    try {
      const cleaned = hotspotJSON
        .replace(/[\u0000-\u001F]/g, "") // removes control characters
        .replace(/\n/g, "\\n")           // escape new lines
        .replace(/\r/g, "");

      hotspotArray = JSON.parse(cleaned);
    } catch (e) {
      return
    }
    let hotspot = hotspotArray[hotspotIndex];
    if (!hotspot) return;

    // Iframe
    if (!hotspot.disableHotspotIframe && hotspot.hotspotIframe) {
      setShowIframe(true);
      setIframeUrl(hotspot.hotspotIframe);
    }

    // Determine language
    const lang = localStorage.getItem("language") || "en";
    const voiceKey = `hotspotVoice${lang === "en" ? "English" : lang === "sl" ? "Sinhala" : "Tamil"
      }`;
    const titleKey = `hotspotTitle${lang === "en" ? "English" : lang === "sl" ? "Sinhala" : "Tamil"
      }`;
    const descriptionKey = `hotspotDescription${lang === "en" ? "English" : lang === "sl" ? "Sinhala" : "Tamil"
      }`;

    // Audio
    const audioUrl = hotspot[voiceKey];
    if (audioUrl) {
      setAudio(new Audio(audioUrl));
      setShowAudio(true);
      setPlayAudio(false);
      audio.pause();
    } else {
      setShowAudio(false);
    }

    // Image
    if (hotspot.hotspotImage) {
      setHotspotImage(hotspot.hotspotImage);
      setTimeout(() => setShowImageLoading(false), 2000);
    }

    // Title & Description
    if (hotspot[titleKey]) setHostpotTitle(hotspot[titleKey]);
    if (hotspot[descriptionKey]) setHostpotDescription(hotspot[descriptionKey]);

    setHotspotOpen(true);
  };

  const handleAudioPlay = () => {
    stopNarrationAudio();
    fadeThemeAudio(0.2, 500);
    audio.play();
    setPlayAudio(true);
  };

  const pauseAudioPlay = () => {
    audio.pause();
    setPlayAudio(false);
    fadeThemeAudio(0.5, 500);
  };

  audio.onended = function () {
    setPlayAudio(false);
    fadeThemeAudio(0.5, 500);
  };

  const handleHotspotClose = () => {
    const clickAudio = new Audio("https://res.cloudinary.com/giglantis/video/upload/v1777459238/TABS_smeb0h.mp3");
    clickAudio.volume = 1;
    clickAudio.play().catch((err) => {
      console.log(err);
    });
    setHotspotOpen(false);
    setFullImageOpen(false);
    setShowAudio(false);
    setPlayAudio(false);
    setIframeUrl("");
    audio.pause();
    setAutoplayEnabled(sessionStorage.getItem("isAutoplayEnabled") === "true");
    setIsPaused(false);
    resumeThemeAudio();
    fadeThemeAudio(0.5, 500);
  };

  const goHome = () => {
    setAnchorEl(null);
    stopNarrationAudio();
    stopThemeAudioBeforeNav();
    const clickAudio = new Audio("https://res.cloudinary.com/giglantis/video/upload/v1777459643/LOCATION_CHANGE_oc2l0j.mp3");
    clickAudio.volume = 1;
    clickAudio.play().catch((err) => {
      console.log(err);
    });
    navigate("/");
  };

  const [isEnter, setIsEnter] = useState(false);

  const navigateToPublicEntrance = () => {
    stopNarrationAudio();
    stopThemeAudioBeforeNav();
    const clickAudio = new Audio("https://res.cloudinary.com/giglantis/video/upload/v1777459643/LOCATION_CHANGE_oc2l0j.mp3");
    clickAudio.volume = 1;
    clickAudio.play().catch((err) => {
      console.log(err);
    });
    navigate("/public-entrance");
  };

  const navigateChamber = () => {
    stopNarrationAudio();
    stopThemeAudioBeforeNav();
    const clickAudio = new Audio("https://res.cloudinary.com/giglantis/video/upload/v1777459643/LOCATION_CHANGE_oc2l0j.mp3");
    clickAudio.volume = 1;
    clickAudio.play().catch((err) => {
      console.log(err);
    });
    navigate("/chamber");
  };

  const [isDrag, setIsDrag] = React.useState(false);

  const onDrag = () => {
    setIsDrag(true);
    setAutoplayEnabled(false);
    setIsPaused(true);
  };

  const onDragLeave = () => {
    setIsDrag(false);
    setAutoplayEnabled(sessionStorage.getItem("isAutoplayEnabled") === "true");
    setIsPaused(false);
  };

  const handleTeamOpen = () => {
    fadeThemeAudio(0.2, 500);
    setAutoplayEnabled(false);
    setIsPaused(true);
    setAnchorEl(null);
    setOpen(false);
    setTutorialOpen(false);
    setTeamOpen(true);
  };

  const handleTeamClose = () => {
    setTeamOpen(false);
    setAutoplayEnabled(sessionStorage.getItem("isAutoplayEnabled") === "true");
    setIsPaused(false);
    resumeThemeAudio();
    fadeThemeAudio(0.5, 500);
  };

  const handleTutorialOpen = () => {
    pauseNarrationAudio();
    fadeThemeAudio(0.2, 500);
    setAutoplayEnabled(false);
    setIsPaused(true);
    setAnchorEl(null);
    setOpen(false);
    setHotspotOpen(false);
    setFullImageOpen(false);
    setShowAudio(false);
    setPlayAudio(false);
    audio.pause();
    setTutorialOpen(true);
    setVariable("Open");
  };

  const handleTutorialClose = () => {
    setTutorialOpen(false);
    setAutoplayEnabled(sessionStorage.getItem("isAutoplayEnabled") === "true");
    setIsPaused(false);
    fadeThemeAudio(0.5, 500);
  };

  const endSliderClick = () => {
    const clickAudio = new Audio("https://res.cloudinary.com/giglantis/video/upload/v1777459238/TABS_smeb0h.mp3");
    clickAudio.volume = 1;
    clickAudio.play().catch((err) => {
      console.log(err);
    });
    setAnchorEl(null);
    setTutorialOpen(false);
    setOpen(false);
    setHotspotOpen(false);
    setFullImageOpen(false);
    setShowAudio(false);
    setPlayAudio(false);
    audio.pause();
    setVariable("Close");
    setAutoplayEnabled(sessionStorage.getItem("isAutoplayEnabled") === "true");
    setIsPaused(false);
    resumeNarrationAudio();
    resumeThemeAudio();
    fadeThemeAudio(0.5, 500);
  };

  const handleFullImageOpen = () => {
    setFullImageOpen(true);
    audio.pause();
    setPlayAudio(false);
  };

  const handleFullImageClose = () => {
    const clickAudio = new Audio("https://res.cloudinary.com/giglantis/video/upload/v1777459238/TABS_smeb0h.mp3");
    clickAudio.volume = 1;
    clickAudio.play().catch((err) => {
      console.log(err);
    });
    setFullImageOpen(false);
  };

  const handlePresentaionViewClose = () => {
    setAnchorEl(null);
    setTutorialOpen(false);
    setOpen(false);
    setHotspotOpen(false);
    setFullImageOpen(false);
    setShowAudio(false);
    setPlayAudio(false);
    setPresentationOpen(false);
    setAutoplayEnabled(sessionStorage.getItem("isAutoplayEnabled") === "true");
    setIsPaused(false);
    fadeThemeAudio(0.5, 500);
  };

  const handlePresentaionViewOpen = () => {
    fadeThemeAudio(0.2, 500);
    setAutoplayEnabled(false);
    setIsPaused(true);
    setAnchorEl(null);
    setTutorialOpen(false);
    setOpen(false);
    setHotspotOpen(false);
    setFullImageOpen(false);
    setShowAudio(false);
    setPlayAudio(false);
    setPresentationOpen(true);
  };

  const handleSnackBarOpen = () => {
    setShowSnackBar(true);
  };

  const handleSnackBarClose = () => {
    setShowSnackBar(false);
  };

  return (
    <Fullscreen isEnter={isEnter} onChange={setIsEnter}>
      <div className="page-container">
        <Invisible />
        {isLoading && <Loading />}
        {showWatermarkLogo &&
          <div
            className="watermark-logo-container"
          >
            <img
              className="watermark-logo"
              src={watermarkLogoUrl}
              alt=""
            />
          </div>
        }
        <div
          className={[
            "all-locations-popup-container",
            open ? "dialog-open" : "dialog-close",
          ].join(" ")}
        >
          <IconButton
            className="all-locations-close-icon"
            onClick={handleClose}
          >
            <CloseIcon />
          </IconButton>
          <AllLocations />
        </div>

        <div
          className={[
            "full-info-dialog",
            fullImageOpen ? "dialog-open" : "dialog-close",
          ].join(" ")}
        >
          <IconButton
            className="close-full-icon"
            onClick={handleFullImageClose}
          >
            <CloseIcon />
          </IconButton>
          <div className="full-dialog-container">
            <img
              className="full-dialog-image"
              src={hotspotImage}
              alt=""
              onContextMenu={(e) => e.preventDefault()}
              draggable="false"
            />
          </div>
        </div>

        <Snackbar
          open={showSnackBar}
          autoHideDuration={6000}
          onClose={handleSnackBarClose}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleSnackBarClose}
            severity="warning"
            sx={{ width: "100%" }}
          >
            Please close the information pop up to resume navigation
          </Alert>
        </Snackbar>

        <div
          className={[
            "info-dialog-popup-container",
            hotspotOpen ? "dialog-open" : "dialog-close",
          ].join(" ")}
        >
          <div
            onClick={handleSnackBarOpen}
            className={[hotspotOpen ? "modal-bg" : ""].join(" ")}
          ></div>
          <IconButton className="info-close-icon" onClick={handleHotspotClose}>
            <CloseIcon />
          </IconButton>
          <div
            className={[
              "info-dialog",
              hotspotText ? "info-dialog-long" : "",
            ].join(" ")}
          >
            {showIframe && (
              <div className="iframe-container">
                <iframe
                  src={iframeUrl}
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerpolicy="strict-origin-when-cross-origin"
                  allowfullscreen
                ></iframe>
              </div>
            )}
            {hotspotImage && showImageLoading && (
              <div className="image-loading-container">
                <div className="square-loader"></div>
                <span className="loading-text">LOADING</span>
              </div>
            )}
            {hotspotImage && !showImageLoading && (
              <img
                className="info-dialog-img info-dialog-img-sm"
                src={hotspotImage}
                alt=""
                onClick={handleFullImageOpen}
                onContextMenu={(e) => e.preventDefault()}
                draggable="false"
              />
            )}
            <div
              className={[
                "info-content-row",
                hotspotText ? "info-content-row-margin" : "",
              ].join(" ")}
            >
              {!showAudio && (
                <div className="flex-row-center">
                  <span className="info-view-text">{hotspotTitle}</span>
                </div>
              )}
              {showAudio && (
                <section>
                  {!playAudio && (
                    <div className="flex-row-center">
                      <span className="info-view-text">{hotspotTitle}</span>
                      <div
                        className="audio-icon-container"
                        onClick={handleAudioPlay}
                      >
                        <div className="audio-img"></div>
                      </div>
                    </div>
                  )}
                  {playAudio && (
                    <div className="audio-container" onClick={pauseAudioPlay}>
                      <ul className="audio-div">
                        <li className="audio-wave"></li>
                        <li className="audio-wave"></li>
                        <li className="audio-wave"></li>
                        <li className="audio-wave"></li>
                        <li className="audio-wave"></li>
                        <li className="audio-wave"></li>
                        <li className="audio-wave"></li>
                        <li className="audio-wave"></li>
                        <li className="audio-wave"></li>
                        <li className="audio-wave"></li>
                        <li className="audio-wave"></li>
                        <li className="audio-wave"></li>
                        <li className="audio-wave"></li>
                        <li className="audio-wave"></li>
                        <li className="audio-wave"></li>
                      </ul>
                      <div
                        className="audio-pause-icon-container"
                        onClick={handleAudioPlay}
                      >
                        <div className="audio-pause-img"></div>
                      </div>
                    </div>
                  )}
                </section>
              )}
              {playAudio && (
                <div className="flex-row-center mt-10p">
                  <span className="info-view-text">{hotspotTitle}</span>
                </div>
              )}
              {hotspotText && (
                <section>
                  <div className="info-desc-container">
                    <span
                      className={[
                        "info-desc",
                        seeMore ? "info-desc-expand" : "",
                        seeMore ? "fade-in" : "",
                      ].join(" ")}
                    >
                      {hotspotText}
                    </span>
                  </div>
                  {!seeMore && (
                    <div
                      className="see-more-less-container"
                      onClick={seeMoreClick}
                    >
                      <span>View More</span>
                      <ExpandMoreIcon />
                    </div>
                  )}
                  {seeMore && (
                    <div
                      className="see-more-less-container"
                      onClick={seeLessClick}
                    >
                      <span>View Less</span>
                      <ExpandLessIcon />
                    </div>
                  )}
                </section>
              )}
            </div>
          </div>
        </div>

        <div
          className={[
            "tutorial-modal-container",
            teamOpen ? "dialog-open" : "dialog-close",
          ].join(" ")}
        >
          <div className="tutorial-popup">
            <div className="team-popup-container">
              <Team onTeamPopupClose={handleTeamClose} variable={variable} />
            </div>
          </div>
        </div>

        <div
          className={[
            "tutorial-modal-container",
            tutorialOpen ? "dialog-open" : "dialog-close",
          ].join(" ")}
        >
          <div className="tutorial-popup">
            <div className="tutorial-popup-container">
              <IconButton
                className="tutorial-inner-close-icon"
                onClick={endSliderClick}
              >
                <CloseIcon />
              </IconButton>
              <TutorialSlider
                onSliderEndClick={endSliderClick}
                variable={variable}
              />
            </div>
          </div>
        </div>

        <div
          className={[
            "presentation-popup-container",
            presentationOpen ? "dialog-open" : "dialog-close",
          ].join(" ")}
        >
          <div className="presentation-popup">
            <div className="tutorial-popup-container">
              <div className="presentation-view-container">
                <span className="presentation-popup-text">
                  Switching to presentation view will load images in high
                  resolution.
                </span>
                <span className="presentation-popup-text">
                  Do you want to continue ?
                </span>
                <div className="presentation-view-btn-row">
                  <Button
                    className="presentation-btn-yes"
                    variant="contained"
                    onClick={handlePresentaionViewClose}
                  >
                    Yes
                  </Button>
                  <Button
                    className="presentation-btn-no"
                    variant="contained"
                    onClick={handlePresentaionViewClose}
                  >
                    No
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {showMenuBtn && (
          <IconButton className="mob-menu-btn" onClick={handleMenuOpen}>
            <MenuOutlinedIcon />
          </IconButton>
        )}
        <Menu
          className="menu-container"
          anchorEl={anchorEl}
          open={menuOpen}
          onClose={handleMenuClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          <MenuItem onClick={goHome}>
            <div className="d-flex align-items-center justify-content-between">
              <HomeOutlinedIcon />
              <span className="mob-menu-item ms-2">{t.home}</span>
            </div>
          </MenuItem>
          <MenuItem onClick={handleTutorialOpen}>
            <div className="d-flex align-items-center justify-content-between">
              <InfoOutlinedIcon />
              <span className="mob-menu-item ms-2">{t.tutorial}</span>
            </div>
          </MenuItem>
          {showTeamDetailsBool && (
            <MenuItem onClick={handleTeamOpen}>
              <div className="d-flex align-items-center justify-content-between">
                <PeopleOutlineOutlinedIcon />
                <span className="mob-menu-item ms-2">{t.team}</span>
              </div>
            </MenuItem>
          )}
          <MenuItem>
            <div className="d-flex align-items-center justify-content-between w-100">
              <span className="mob-menu-item me-2">{t.themeAudio}</span>
              <label className="switch">
                <input
                  type="checkbox"
                  checked={themeAudioEnabled}
                  onChange={handleThemeAudioToggle}
                />
                <span className="slider round"></span>
              </label>
            </div>
          </MenuItem>
          <MenuItem>
            <div className="d-flex align-items-center justify-content-between w-100">
              <span className="mob-menu-item me-2">{t.autoplay}</span>
              <label className="switch">
                <input
                  type="checkbox"
                  checked={autoplayEnabled}
                  onChange={handleAutoplayToggle}
                />
                <span className="slider round"></span>
              </label>
            </div>
          </MenuItem>
        </Menu>
        <div
          className={[
            "pannellum-image",
            imageIndex == 1
              ? "pannellum-image-fade-in"
              : "pannellum-image-fade-out",
          ].join(" ")}
        >
          <Pannellum
            width="100%"
            height="100vh"
            image={imageOneSrc}
            pitch={1}
            yaw={360}
            hfov={hfov}
            autoLoad
            showZoomCtrl={false}
            showFullscreenCtrl={false}
            onLoad={() => {
              onImageLoad();
            }}
            onMousedown={(evt) => {
              onDrag();
            }}
            onMouseup={(evt) => {
              onDragLeave();
            }}
            onTouchstart={(evt) => {
              onDrag();
            }}
            onTouchend={(evt) => {
              onDragLeave();
            }}
          >
            <Pannellum.Hotspot
              type="custom"
              cssClass="loc-hotspot"
              pitch={-10}
              yaw={-0.5}
              handleClick={(evt, name) => handleHotspotClickOpen(0)}
              name="hs11"
            />
          </Pannellum>
        </div>

        <section
          className={[
            "footer-section",
            isShowFooter ? "show-footer" : "hide-footer",
          ].join(" ")}
        >
          <div
            className={[
              "footer-container",
              isDrag ? "footer-fade-out" : "footer-fade-in",
            ].join(" ")}
          >
            <Button
              onClick={handleClickOpen}
              className="locations-btn"
              variant="outlined"
              startIcon={<MenuIcon />}
            >
              {localStorage.getItem("language") == "en" && (
                <span>All Locations</span>
              )}
              {localStorage.getItem("language") == "sl" && (
                <span>සියලුම ස්ථාන</span>
              )}
              {localStorage.getItem("language") == "tm" && (
                <span>அனைத்து இடங்களும்</span>
              )}
            </Button>
            <div className="stepper-container">
              <IconButton
                className="prev-next-icon"
                onClick={() => goPrevious()}
              >
                <ArrowBackIosNewIcon />
              </IconButton>
              <div className="stepper-nav-container">
                <div className="stepper-locations">
                  <span
                    className={[
                      "stepper-location-name",
                      localStorage.getItem("language") == "tm" ? "w-160" : "",
                    ].join(" ")}
                    onClick={navigateToPublicEntrance}
                  >
                    {localStorage.getItem("language") == "en" && (
                      <span>Public Entrance</span>
                    )}
                    {localStorage.getItem("language") == "sl" && (
                      <span>කාර්ය මණ්ඩල පිවිසුම</span>
                    )}
                    {localStorage.getItem("language") == "tm" && (
                      <span>பணியாளர் நுழைவாயில்</span>
                    )}
                  </span>
                  <span
                    className={[
                      "stepper-location-name-active",
                      localStorage.getItem("language") == "sl"
                        ? "mlp-sds"
                        : "mlp-sd",
                      localStorage.getItem("language") == "tm"
                        ? "mlpm-68"
                        : "mlp-sd",
                    ].join(" ")}
                  >
                    {locationName}
                  </span>
                  <span
                    className="stepper-location-name"
                    onClick={navigateChamber}
                  >
                    {localStorage.getItem("language") == "en" && (
                      <span>Chamber</span>
                    )}
                    {localStorage.getItem("language") == "sl" && (
                      <span>සභා ගර්භ‌ය</span>
                    )}
                    {localStorage.getItem("language") == "tm" && (
                      <span>சபாபீடம</span>
                    )}
                  </span>
                </div>
                <div className="stepper-navigations">
                  <span
                    className="stepper-navigations-name"
                    onClick={() => goPrevious()}
                  >
                    {localStorage.getItem("language") == "en" && (
                      <span>Previous</span>
                    )}
                    {localStorage.getItem("language") == "sl" && (
                      <span>පෙර</span>
                    )}
                    {localStorage.getItem("language") == "tm" && (
                      <span>முந்தைய</span>
                    )}
                  </span>
                  <span className="stepper-line-left"></span>
                  <div className="stepper-circle-container">
                    <section
                      className={[""].join(
                        " "
                      )}
                      onClick={() => changeImage(1)}
                    >
                      <div
                        className={[
                          "stepper-square-multi",
                          imageIndex === 1 ? "active-stepper-square" : ""
                        ].join(" ")}
                      >
                      </div>
                    </section>
                  </div>
                  {autoplayEnabled && countdown !== null && (
                    <div
                      className="autoplay-timer-container"
                      onClick={() => setIsPaused((prev) => !prev)}
                    >
                      {!isPaused ? (
                        <div className="d-flex align-items-center">
                          <span className="autoplay-timer">{countdown}</span>
                          <span className="autoplay-arrows">
                            <span className="chev chev-1"></span>
                            <span className="chev chev-2"></span>
                          </span>
                        </div>
                      ) : (
                        <div className="autoplay-play-btn">
                          <span className="play-icon">
                            <PlayArrowOutlinedIcon className="small-play" />
                          </span>
                        </div>
                      )}
                    </div>
                  )}
                  <span className="stepper-line-right"></span>
                  <span
                    className="stepper-navigations-name"
                    onClick={() => goNext()}
                  >
                    {localStorage.getItem("language") == "en" && (
                      <span>Next</span>
                    )}
                    {localStorage.getItem("language") == "sl" && (
                      <span>ඊළඟ</span>
                    )}
                    {localStorage.getItem("language") == "tm" && (
                      <span>அடுத்தது</span>
                    )}
                  </span>
                </div>
              </div>
              <IconButton className="prev-next-icon" onClick={() => goNext()}>
                <ArrowForwardIosIcon />
              </IconButton>
            </div>
            <section
              className={[
                "footer-icon-section",
                isEnter ? "exit-full-screen" : "",
              ].join(" ")}
            >
              <FooterIconBar
                onOpenTutorial={handleTutorialOpen}
                onOpenTeam={handleTeamOpen}
                onFullscreenToggle={() => {
                  setIsEnter(!isEnter);
                }}
                themeAudioEnabled={themeAudioEnabled}
                themeAudioToggle={handleThemeAudioToggle}
                autoplayEnabled={autoplayEnabled}
                onAutoplayToggle={handleAutoplayToggle}
                onMenuToggle={handleFooterMenuToggle}
              />
            </section>
          </div>
          <div
            className={[
              "footer-container-mob",
              isDrag ? "footer-fade-out" : "footer-fade-in",
            ].join(" ")}
          >
            <IconButton className="prev-next-icon" onClick={() => goPrevious()}>
              <ArrowBackIosNewIcon />
            </IconButton>
            <div className="flex-column-container">
              <div className="d-flex align-items-center">
                <div className="stepper-circle-container">
                  <section
                    className={[""].join(" ")}
                    onClick={() => changeImage(1)}
                  >
                    <div
                      className={[
                        "stepper-square-multi",
                        imageIndex === 1 ? "active-stepper-square" : ""
                      ].join(" ")}
                    >
                    </div>
                  </section>
                </div>
                {autoplayEnabled && countdown !== null && (
                  <div
                    className="autoplay-timer-container"
                    onClick={() => setIsPaused((prev) => !prev)}
                  >
                    {!isPaused ? (
                      <div className="d-flex align-items-center">
                        <span className="autoplay-timer">{countdown}</span>
                        <span className="autoplay-arrows">
                          <span className="chev chev-1"></span>
                          <span className="chev chev-2"></span>
                        </span>
                      </div>
                    ) : (
                      <div className="autoplay-play-btn">
                        <span className="play-icon">
                          <PlayArrowOutlinedIcon className="small-play" />
                        </span>
                      </div>
                    )}
                  </div>
                )}
              </div>
              <span className="stepper-location-name-active">
                {locationName}
              </span>
              <span className="locations-btn-link" onClick={handleClickOpen}>
                {localStorage.getItem("language") == "en" && (
                  <span>All Locations</span>
                )}
                {localStorage.getItem("language") == "sl" && (
                  <span>සියලුම ස්ථාන</span>
                )}
                {localStorage.getItem("language") == "tm" && (
                  <span>அனைத்து இடங்களும்</span>
                )}
              </span>
            </div>
            <IconButton className="prev-next-icon" onClick={() => goNext()}>
              <ArrowForwardIosIcon />
            </IconButton>
          </div>
        </section>
      </div>
    </Fullscreen>
  );
};

export default SilverDoor;
